import React from 'react';
interface ContactFormProps {
  idPrefix?: string;
  buttonText?: string;
}
export function ConsultationForm({
  idPrefix = 'contact',
  buttonText = 'Contact FSG'
}: ContactFormProps) {
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = Object.fromEntries(new FormData(e.currentTarget).entries());
    // Connect this form to the live WebsiteForge/Jotform/GHL endpoint before launch.
    // eslint-disable-next-line no-console
    console.log('FSG Transport lead:', data);
  };
  const id = (field: string) => `${idPrefix}-${field}`;
  const fieldClass = 'w-full bg-off-white border-2 border-steel px-4 py-3.5 rounded-sm focus:outline-none focus:ring-2 focus:ring-navy focus:border-transparent transition-colors font-medium text-navy placeholder:text-navy/30';
  const labelClass = 'block text-xs font-bold uppercase tracking-wider text-navy/70 mb-2';
  return <form className="space-y-6" method="POST" onSubmit={handleSubmit} data-id="element-64">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-65">
        <div data-id="element-66">
          <label htmlFor={id('name')} className={labelClass} data-id="element-67">
            Name *
          </label>
          <input id={id('name')} name="name" required type="text" autoComplete="name" className={fieldClass} placeholder="Full name" data-id="element-68" />
        </div>
        <div data-id="element-69">
          <label htmlFor={id('phone')} className={labelClass} data-id="element-70">
            Phone *
          </label>
          <input id={id('phone')} name="phone" required type="tel" autoComplete="tel" className={fieldClass} placeholder="Best phone number" data-id="element-71" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-72">
        <div data-id="element-73">
          <label htmlFor={id('email')} className={labelClass} data-id="element-74">
            Email *
          </label>
          <input id={id('email')} name="email" required type="email" autoComplete="email" className={fieldClass} placeholder="Email address" data-id="element-75" />
        </div>
        <div data-id="element-76">
          <label htmlFor={id('company')} className={labelClass} data-id="element-77">
            Company Name
          </label>
          <input id={id('company')} name="company" type="text" autoComplete="organization" className={fieldClass} placeholder="Company name" data-id="element-78" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-79">
        <div data-id="element-80">
          <label htmlFor={id('company_setup')} className={labelClass} data-id="element-81">
            Company Setup
          </label>
          <select id={id('company_setup')} name="company_setup" defaultValue="" className={`${fieldClass} appearance-none`} data-id="element-82">
            <option value="" disabled data-id="element-83">
              Select one...
            </option>
            <option value="own_authority" data-id="element-84">Have my own authority</option>
            <option value="lease_on" data-id="element-85">Looking to lease on</option>
            <option value="trailer_rental" data-id="element-86">Need trailer rental</option>
            <option value="not_sure" data-id="element-87">Not sure yet</option>
          </select>
        </div>
        <div data-id="element-88">
          <label htmlFor={id('equipment_type')} className={labelClass} data-id="element-89">
            Equipment Type
          </label>
          <select id={id('equipment_type')} name="equipment_type" defaultValue="" className={`${fieldClass} appearance-none`} data-id="element-90">
            <option value="" disabled data-id="element-91">
              Select one...
            </option>
            <option value="dry_van" data-id="element-92">Dry van</option>
            <option value="reefer" data-id="element-93">Reefer</option>
            <option value="flatbed" data-id="element-94">Flatbed</option>
            <option value="step_deck" data-id="element-95">Step deck</option>
            <option value="power_only" data-id="element-96">Power only</option>
            <option value="other" data-id="element-97">Other</option>
          </select>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-98">
        <div data-id="element-99">
          <label htmlFor={id('trucks')} className={labelClass} data-id="element-100">
            Number of Trucks
          </label>
          <select id={id('trucks')} name="trucks" defaultValue="" className={`${fieldClass} appearance-none`} data-id="element-101">
            <option value="" disabled data-id="element-102">
              Select...
            </option>
            <option value="1" data-id="element-103">1</option>
            <option value="2-5" data-id="element-104">2–5</option>
            <option value="6+" data-id="element-105">6+</option>
          </select>
        </div>
        <div className="md:col-span-2" data-id="element-106">
          <label htmlFor={id('mc_dot')} className={labelClass} data-id="element-107">
            MC / DOT Number (if applicable)
          </label>
          <input id={id('mc_dot')} name="mc_dot" type="text" className={fieldClass} placeholder="MC or DOT #" data-id="element-108" />
        </div>
      </div>

      <div data-id="element-109">
        <label htmlFor={id('headache')} className={labelClass} data-id="element-110">
          Biggest Headache
        </label>
        <select id={id('headache')} name="headache" defaultValue="" className={`${fieldClass} appearance-none`} data-id="element-111">
          <option value="" disabled data-id="element-112">
            Select one...
          </option>
          <option value="better_loads" data-id="element-113">Need better loads</option>
          <option value="dispatch_help" data-id="element-114">Need dispatch help</option>
          <option value="paperwork" data-id="element-115">Too much paperwork</option>
          <option value="broker_setup" data-id="element-116">Broker setup/verification</option>
          <option value="billing" data-id="element-117">Billing/rate cons</option>
          <option value="lease_on" data-id="element-118">Looking to lease on</option>
          <option value="other" data-id="element-119">Other</option>
        </select>
      </div>

      <div data-id="element-120">
        <label htmlFor={id('message')} className={labelClass} data-id="element-121">
          Message
        </label>
        <textarea id={id('message')} name="message" rows={4} className={fieldClass} placeholder="Tell us what is slowing you down — loads, paperwork, brokers, billing, or dispatch." data-id="element-122"></textarea>
      </div>

      {/* CAPTCHA / spam-prevention placeholder.
            Connect this CAPTCHA to the live spam-prevention system before launch. */}
      <div id={id('captcha')} className="flex items-center gap-3 bg-off-white border-2 border-dashed border-steel rounded-sm p-4" role="group" aria-label="CAPTCHA verification" data-id="element-123">
        <div className="w-6 h-6 shrink-0 border-2 border-steel rounded-sm bg-white" aria-hidden="true" data-id="element-124"></div>
        <span className="text-sm font-bold text-navy/70 uppercase tracking-wider" data-id="element-125">
          CAPTCHA verification
        </span>
      </div>

      <button type="submit" className="btn-primary w-full py-4 text-base shadow-lg hover:shadow-xl" data-id="element-126">
        {buttonText}
      </button>
    </form>;
}